import React from 'react';
import PropTypes from 'prop-types';

const UpDownArrow = ({ width, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="#7c7d74" d="M1 21h22L12 2" />
      <path fill="#7c7d74" d="M1 3h22L12 22" transform="translate(0,30)" />
    </svg>
  );
};

UpDownArrow.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};

UpDownArrow.defaultProps = {
  width: 12,
  height: 12
};

export default UpDownArrow;
